import Styles from './Carousels.module.scss'
import { SectionHeader } from './SectionHeader'
import { MediaFileCarousel } from './MediaFileCarousel'
import { useUnsplashPhotos } from 'components/Design/UploadsTab/useUnsplashPhotos'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { StockPhotosDrawer } from '../Grids/StockPhotosDrawer'
import { useMediaPickerContext } from '../MediaPickerContext'
const title = 'Stock Photos'

export const StockPhotos = observer(() => {
  const { handleSelect } = useMediaPickerContext()
  const { openDrawer } = useRootStore().drawersStore
  const { results, isLoading } = useUnsplashPhotos({ query: '' })

  const files = results.slice(0, 6).map((result) => ({
    id: result.regular,
    source_url: result.regular,
    mime_type: 'image/png',
    width: result.width,
    height: result.height,
    variants: [],
    title: new URL(result.regular).pathname.split('/').pop() || 'Untitled',
  }))

  if (!isLoading && files.length === 0) return null

  const openStockPhotosDrawer = () => {
    openDrawer(StockPhotosDrawer, { title, onSelect: handleSelect })
  }

  return (
    <MobileWizard.Section gap={8}>
      <SectionHeader title={title} onPress={openStockPhotosDrawer} />
      <div className={Styles.sectionContainer}>
        <MediaFileCarousel mediaFiles={files} isLoading={isLoading} needsDownload provider="stockPhoto" />
      </div>
    </MobileWizard.Section>
  )
})
